import { PropsWithChildren } from 'react';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import S from './BusinessPayments.module.scss';
export const BusinessPaymentLayout = (props: PropsWithChildren<{
  isCenter?: boolean;
  title: string;
}>) => {
  const {
    isCenter = false
  } = props;
  const {
    t
  } = useTranslation(['business']);
  return <div className={cns({
    [S.page_body]: true,
    [S.center_display]: isCenter
  })} data-sentry-component="BusinessPaymentLayout" data-sentry-source-file="BusinessPaymentLayout.tsx">
      <h1 className={cns({
      [S.page_title]: true,
      [S.margin_top_100]: !isCenter
    })}>
        {t('business:business_payments_title')}
        {props.title ? `(${props.title})` : ''}
      </h1>
      {props.children}
      <PaymentsFooter data-sentry-element="PaymentsFooter" data-sentry-source-file="BusinessPaymentLayout.tsx" />
    </div>;
};
const PaymentsFooter = () => {
  const {
    t
  } = useTranslation(['business', 'layout']);
  return <div className={S.payments_footer} data-sentry-component="PaymentsFooter" data-sentry-source-file="BusinessPaymentLayout.tsx">
      <div>
        <span>{t('layout:footer_companyname')}</span>
        <Wall data-sentry-element="Wall" data-sentry-source-file="BusinessPaymentLayout.tsx" />
        <span>{t('layout:footer_ceo')}</span>
        <Wall data-sentry-element="Wall" data-sentry-source-file="BusinessPaymentLayout.tsx" />
        <span>{t('layout:footer_biz_num')}</span>
        <Wall data-sentry-element="Wall" data-sentry-source-file="BusinessPaymentLayout.tsx" />
        <span>{t('layout:footer_commerce_num')}</span>
      </div>
      <div>
        <span>{t('layout:footer_address')}</span>
        <Wall data-sentry-element="Wall" data-sentry-source-file="BusinessPaymentLayout.tsx" />
        <span>{t('layout:footer_fax')}</span>
        <Wall data-sentry-element="Wall" data-sentry-source-file="BusinessPaymentLayout.tsx" />
        <span>{t('layout:footer_email')}</span>
      </div>
    </div>;
};
const Wall = () => <span className={S.wall} data-sentry-component="Wall" data-sentry-source-file="BusinessPaymentLayout.tsx">|</span>;